export const formatAmount = (value, options = {}) => {
  const { decimals = 2, trimTrailingZeros = false } = options;
  if (value === undefined || value === null || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);

  const formatted = num.toFixed(decimals);
  if (trimTrailingZeros) {
    // Remove trailing zeros and optional decimal point
    return formatted.replace(/\.0+$/, "").replace(/(\.[1-9]*?)0+$/, "$1");
  }
  return formatted;
};

export const formatCurrency = (value, currencyCode, options = {}) => {
  if (value === undefined || value === null || value === "") return "-";
  const num = Number(value);
  if (Number.isNaN(num)) return String(value);
  try {
    const { maximumFractionDigits = 2, minimumFractionDigits = 2 } = options;
    if (currencyCode) {
      return new Intl.NumberFormat(undefined, {
        style: "currency",
        currency: currencyCode,
        maximumFractionDigits,
        minimumFractionDigits,
      }).format(num);
    }
    return new Intl.NumberFormat(undefined, {
      maximumFractionDigits,
      minimumFractionDigits,
    }).format(num);
  } catch (_) {
    return formatAmount(num, { decimals: options?.maximumFractionDigits ?? 2 });
  }
};

export default formatAmount;


